<div class="container-fluid io-news content-padded">
    <div class="row">
        <div class="col-lg-9 col-md-12 col-xs-12 blogs-container">
            <div class="blogs-container-flex">
              <h2 class="title-header">{{'Welcome to Spotlight on Immunotherapy where we highlight blogs, videos, articles, webinars, and more!' | translate}} </h2>
              <h5 class="title-subheader">{{'Check back each week as we bring you different voices and perspectives on the immunotherapy and cancer experience.' | translate}}</h5>
                <div class="blog row" *ngFor="let blog of blogsArray">
                    <div class="col-md-12 blog-item">
                        <div class="blog-img">
                            <img *ngIf="!isLoadingBlogs" [src]="getImgUrl(blog.blogId)" (error)="imgError($event)" alt="">
                        </div>
                        <div class="blog-content">
                            <!-- Title -->
                            <h2 *ngIf="!isLoadingBlogs" class="title">
                                {{blog.name}}
                            </h2>
                            <span *ngIf="isLoadingBlogs" class="loading title"></span>

                            <!-- Description -->
                            <span [innerHTML]="blog.description | safeHtml" *ngIf="!isLoadingBlogs" class="description"></span>
                            <span *ngIf="isLoadingBlogs" class="loading description"></span>
                            <div class="read-more-container">
                                <a (click)="goToBlog(blog.blogId)" class="read-more-link" (click)="goToBlog(blog.blogId)">{{'Read More' | translate}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blog-empty" *ngIf="isBlogsEmpty">
                    <h5 class="text-empty">There are no blogs at this moment</h5>
                </div>
            </div>
            <div class="row pagination-container-flex">
                <!--<pagination [boundaryLinks]="false" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" (pageChanged)="pageChanged($event)"
                    [(ngModel)]="currentPage" class="pagination-md" previousText="&lsaquo;" nextText="&rsaquo;"></pagination>-->
            </div>
        </div>
        <div class="col-lg-3 col-md-12 thumbnails-container thumbnails-side">
            <app-thumb-learn-about-io [routerLink]="['/learn-about-io']"></app-thumb-learn-about-io>
            <app-thumb-living-with-cancer></app-thumb-living-with-cancer>
            <app-thumb-join-today></app-thumb-join-today>
        </div>
    </div>
</div>
